import { faArrowCircleRight, faHeadphonesAlt, faMicrophone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useMe } from "../hooks/useMe";
import { UserRole } from "../__generated__/globalTypes";

export const Profile = () => {
  const { data } = useMe();

  return (
    <div className="h-screen bg-black text-white">
      <Helmet>
        <title>Profile | Pocast</title>
      </Helmet>
      <div className="flex flex-col justify-center text-center">
        <div className="relative  h-72">
          <div
            style={{ backgroundImage: `url(assets/profile-bg.jpeg)` }}
            className="text-gray-300  h-full bg-center absolute top-0 left-0 w-full z-0 opacity-30"
          />
          <div className="pt-10 z-10 relative  flex flex-col justify-center items-center">
            {data?.me.role === UserRole.Host ? (
              <FontAwesomeIcon icon={faMicrophone} className=" text-9xl" />
            ) : (
              <FontAwesomeIcon icon={faHeadphonesAlt} className=" text-9xl" />
            )}

            <div className="mt-4 inline py-0.5 bg-pink-700 px-2 rounded-lg font-bold">{data?.me.role}</div>
            <div className="mt-2 tracking-wider white">{data?.me.email}</div>
          </div>
        </div>
      </div>
      <div className="flex flex-col px-5  sm:w-3/6 mx-auto py-4">
        <div className="text-left text-xl text-pink-700 font-bold mb-2">Edit Profile</div>

        <div className="text-lg text-gray-400 px-2">
          <div className="flex flex-col items-start">
            <Link to="/edit-profile" className="mb-4 hover:text-purple-700">
              <FontAwesomeIcon icon={faArrowCircleRight} className="mr-5" />
              Edit profile
            </Link>
          </div>
        </div>

        {data?.me.role === UserRole.Host && (
          <>
            <div className="text-left text-xl text-pink-700 font-bold mb-2 mt-2">Manage Podcasts</div>

            <div className="text-lg text-gray-400 px-2">
              <div className="flex flex-col items-start">
                <Link to="/create-podcast" className="mb-4 hover:text-purple-700">
                  <FontAwesomeIcon icon={faArrowCircleRight} className="mr-5" />
                  Upload Podcast
                </Link>
                <Link to="manage-podcasts" className="mb-4 hover:text-purple-700">
                  <FontAwesomeIcon icon={faArrowCircleRight} className="mr-5" />
                  Edit Podcast
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
